import { useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { TranscriptionModal } from 'screens/BrandKits/components/SourceMaterialModal/TranscriptionModal'
import { AlignLeft } from 'blaze-ui/icons'
import { ButtonSize, ButtonVariant } from 'blaze-ui/Button/Types'

export const ShowTranscriptionButton = ({
  content,
  size = 'xs',
  variant = 'tertiary',
}: {
  content: string
  size?: ButtonSize
  variant?: ButtonVariant
}) => {
  const { openModal } = useModals()

  return (
    <Button
      variant={variant}
      size={size}
      onPress={() => openModal(TranscriptionModal, { content })}
      frontIcon={AlignLeft}
      aria-label="Show Transcribed Text"
    >
      Show Transcribed Text
    </Button>
  )
}
